import { render, staticRenderFns } from "./DepositRuleTable.vue?vue&type=template&id=1dba8058"
import script from "./DepositRuleTable.vue?vue&type=script&lang=ts"
export * from "./DepositRuleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports